const MODULE_NAME = "LOGIN";
const PROCESSING = MODULE_NAME + "PROCESSING";
const COMPLETE = MODULE_NAME + "COMPLETE";
const FAIL = MODULE_NAME + "FAIL";
const FETCH_TENANT_MODULES_STARTED = MODULE_NAME + "FETCH_TENANT_MODULES_STARTED";
const FETCH_TENANT_MODULES_COMPLETED = MODULE_NAME + "FETCH_TENANT_MODULES_COMPLETED";

export {
  PROCESSING, COMPLETE, FAIL,
  FETCH_TENANT_MODULES_STARTED,
  FETCH_TENANT_MODULES_COMPLETED
};
